import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';

interface SubmitCommentParams {
  dataSetId: number;
  comment: string;
  selectedRows?: any[];
}

interface UseE55SubmitCommentOptions {
  onSuccess?: () => void;
  onError?: (error: any) => void;
}

/**
 * Hook to submit a comment for a specific E55 dataset
 * 
 * @param options Success and error callback options
 * @returns Mutation hook for submitting comments
 */
export const useE55SubmitComment = (options?: UseE55SubmitCommentOptions) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ dataSetId, comment, selectedRows }: SubmitCommentParams) => {
      const response = await axios.post(`/data-set/e55/${dataSetId}/comment`, comment, {
        headers: {
          'Content-Type': 'text/plain'
        }
      });
      return response.data;
    },
    onSuccess: (data, variables) => {
      // Invalidate comments query to trigger refetch
      queryClient.invalidateQueries({ queryKey: ['e55Comments', variables.dataSetId] });
      
      // Call the provided success callback
      options?.onSuccess?.();
    },
    onError: (error) => {
      // Call the provided error callback
      options?.onError?.(error);
    }
  });
}; 